export const ru = {
    'create-on-preset': 'Создать по шаблону',
    creatives: 'Мои креативы',
    ideas: 'Идеи креативов',
    presets: 'Стандартные шаблоны',
    title: 'Конструктор креативов'
};
